import { TransportistaComponent } from './../pages/facturador/transportista/transportista.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExtrapagesRoutingModule } from './extrapages-routing.module';

import { MaintenanceComponent } from './maintenance/maintenance.component';
import { Page404Component } from './page404/page404.component';
import { Page500Component } from './page500/page500.component';
import { Login1Component } from './login1/login1.component';
import { RecoverpasswordComponent } from './recoverpassword/recoverpassword.component';
import { LockscreenComponent } from './lockscreen/lockscreen.component';
import { PlanesComponent } from './planes/planes.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [ MaintenanceComponent, Page404Component, Page500Component,
     Login1Component, RecoverpasswordComponent, LockscreenComponent, PlanesComponent],
  imports: [
    CommonModule,NgSelectModule,FormsModule,FullCalendarModule,NgbDatepickerModule,
    ExtrapagesRoutingModule,DropzoneModule,ReactiveFormsModule
  ]
})
export class ExtrapagesModule { }
